(() => {
  if (window.__quickAddIconInit) return;
  window.__quickAddIconInit = true;

  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function hoistModals() {
    document.querySelectorAll('.qa-modal').forEach((modal) => {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  hoistModals();
  new MutationObserver(hoistModals).observe(document.body, { childList: true, subtree: true });

  function openModal(modal) {
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';

    const firstBundle = modal.querySelector('.qa-modal__bundle-btn');
    if (firstBundle && !modal.querySelector('.qa-modal__bundle-btn.is-active')) {
      firstBundle.classList.add('is-active');
    }

    const track = modal.querySelector('[data-qa-gallery-track]');
    if (track) track.scrollLeft = 0;

    goToSlide(modal, 0);
  }

  function closeModal(modal) {
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  /* ─── Gallery: go to specific slide ─── */
  function goToSlide(modal, idx) {
    const slides = modal.querySelectorAll('.qa-modal__gallery-slide');
    const thumbs = modal.querySelectorAll('.qa-modal__thumb');
    const isMobile = window.innerWidth < 750;

    if (isMobile) {
      const track = modal.querySelector('[data-qa-gallery-track]');
      if (track && slides[idx]) {
        slides[idx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    } else {
      slides.forEach((s, i) => {
        s.classList.toggle('is-active', i === idx);
      });
    }

    thumbs.forEach((t, i) => {
      t.classList.toggle('is-active', i === idx);
    });

    modal._currentSlide = idx;
  }

  function galleryNav(modal, dir) {
    const slides = modal.querySelectorAll('.qa-modal__gallery-slide');
    if (!slides.length) return;
    const current = modal._currentSlide || 0;
    let next = current + dir;
    if (next < 0) next = slides.length - 1;
    if (next >= slides.length) next = 0;
    goToSlide(modal, next);
  }

  function updateQty(modal, delta) {
    const input = modal.querySelector('[data-qa-qty-input]');
    if (!input) return;
    const val = Math.max(1, parseInt(input.value, 10) + delta);
    input.value = val;
    modal.querySelectorAll('.qa-modal__bundle-btn').forEach(b => b.classList.remove('is-active'));
    const match = modal.querySelector(`[data-qa-bundle-qty="${val}"]`);
    if (match) match.classList.add('is-active');
  }

  function selectBundle(modal, btn) {
    const qty = parseInt(btn.dataset.qaBundleQty, 10);
    const input = modal.querySelector('[data-qa-qty-input]');
    if (input) input.value = qty;
    modal.querySelectorAll('.qa-modal__bundle-btn').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');
  }

  /* ─── Variant selection via dropdowns ─── */
  function resolveVariant(modal) {
    const jsonEl = modal.querySelector('[data-qa-variants-json]');
    if (!jsonEl) return;

    let variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) { return; }

    const selects = modal.querySelectorAll('.qa-modal__select');
    const selectedOptions = [];
    selects.forEach(s => selectedOptions.push(s.value));

    const matched = variants.find(v => {
      return v.options.every((opt, i) => opt === selectedOptions[i]);
    });

    const addBtn = modal.querySelector('[data-qa-add-to-cart]');
    if (!addBtn) return;

    if (matched) {
      addBtn.dataset.qaVariantId = matched.id;
      addBtn.disabled = !matched.available;

      const label = addBtn.querySelector('[data-qa-add-label]');
      if (label) {
        label.textContent = matched.available ? 'In den Warenkorb legen' : 'Ausverkauft';
      }
    }
  }

  async function addToCart(modal) {
    const addBtn = modal.querySelector('[data-qa-add-to-cart]');
    if (!addBtn || addBtn.disabled) return;

    const variantId = parseInt(addBtn.dataset.qaVariantId, 10);
    const qtyInput = modal.querySelector('[data-qa-qty-input]');
    const quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10)) : 1;

    addBtn.disabled = true;
    const label = addBtn.querySelector('[data-qa-add-label]');
    const origText = label ? label.textContent : '';
    if (label) label.textContent = 'Wird hinzugefügt…';

    try {
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const sections = cart ? cart.getSectionsToRender().map(s => s.id).join(',') : '';

      const body = { items: [{ id: variantId, quantity }] };
      if (sections) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
      }

      const resp = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(body),
      });
      const data = await resp.json();

      if (data.status) {
        if (label) label.textContent = data.description || 'Fehler';
        setTimeout(() => { if (label) label.textContent = origText; }, 2000);
        return;
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: String(variantId),
          cartData: data,
        });
      }

      const cartEl = document.querySelector('cart-drawer');
      if (cartEl && data.sections) {
        if (data.sections['cart-drawer']) {
          const drawerDoc = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
          const newDrawer = drawerDoc.querySelector('#CartDrawer');
          const oldDrawer = document.getElementById('CartDrawer');
          if (newDrawer && oldDrawer) oldDrawer.innerHTML = newDrawer.innerHTML;
          cartEl.classList.remove('is-empty');
          const overlay = cartEl.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', () => cartEl.close());
        }
        if (data.sections['cart-icon-bubble']) {
          const bubbleDoc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          const newBubble = bubbleDoc.querySelector('.shopify-section');
          const oldBubble = document.getElementById('cart-icon-bubble');
          if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
        }
      } else {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          const bubbleResp = await fetch(root() + 'cart?section_id=cart-icon-bubble', { credentials: 'same-origin' });
          const html = new DOMParser().parseFromString(await bubbleResp.text(), 'text/html');
          const newBubble = html.querySelector('#cart-icon-bubble');
          if (newBubble) bubble.innerHTML = newBubble.innerHTML;
        }
      }

      closeModal(modal);
    } catch (err) {
      console.error('Quick add error:', err);
      if (label) label.textContent = 'Fehler – bitte erneut versuchen';
      setTimeout(() => { if (label) label.textContent = origText; }, 2000);
    } finally {
      addBtn.disabled = false;
      if (label && label.textContent === 'Wird hinzugefügt…') label.textContent = origText;
    }
  }

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-quick-add-modal-open]');
    if (openBtn) {
      e.preventDefault();
      e.stopPropagation();
      const modal = document.querySelector(openBtn.dataset.quickAddModalOpen);
      if (modal) openModal(modal);
      return;
    }

    const closeBtn = e.target.closest('[data-quick-add-modal-close]');
    if (closeBtn) {
      const modal = closeBtn.closest('.qa-modal');
      if (modal) closeModal(modal);
      return;
    }

    const prevBtn = e.target.closest('[data-qa-gallery-prev]');
    if (prevBtn) {
      galleryNav(prevBtn.closest('.qa-modal'), -1);
      return;
    }

    const nextBtn = e.target.closest('[data-qa-gallery-next]');
    if (nextBtn) {
      galleryNav(nextBtn.closest('.qa-modal'), 1);
      return;
    }

    const thumbBtn = e.target.closest('[data-qa-thumb-idx]');
    if (thumbBtn) {
      const idx = parseInt(thumbBtn.dataset.qaThumbIdx, 10);
      goToSlide(thumbBtn.closest('.qa-modal'), idx);
      return;
    }

    const minusBtn = e.target.closest('[data-qa-qty-minus]');
    if (minusBtn) {
      updateQty(minusBtn.closest('.qa-modal'), -1);
      return;
    }

    const plusBtn = e.target.closest('[data-qa-qty-plus]');
    if (plusBtn) {
      updateQty(plusBtn.closest('.qa-modal'), 1);
      return;
    }

    const bundleBtn = e.target.closest('[data-qa-bundle-qty]');
    if (bundleBtn) {
      selectBundle(bundleBtn.closest('.qa-modal'), bundleBtn);
      return;
    }

    const addBtn = e.target.closest('[data-qa-add-to-cart]');
    if (addBtn) {
      addToCart(addBtn.closest('.qa-modal'));
      return;
    }
  });

  document.addEventListener('change', (e) => {
    const select = e.target.closest('.qa-modal__select');
    if (select) {
      resolveVariant(select.closest('.qa-modal'));
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const modal = document.querySelector('.qa-modal:not([hidden])');
      if (modal) closeModal(modal);
    }
  });
})();
